/**
 * Account Popover secondary routes with no real page behind them yet
 * (VISTOERA_CANVAS_AS_PRIMARY_HOME_AND_GLOBAL_ACCOUNT_ENTRY_V1 §30/§34/§35/§39).
 *
 * Spec is explicit: when a menu entry (Profile / Plan & Usage / Settings
 * / Help & Tutorials) has no existing backing page, build ONLY a
 * canonical route + a "coming soon" placeholder — never a fake page, and
 * never link to a 404. Reuses the exact same `ComingSoon` component
 * every other not-yet-built page in this app already uses (see
 * `App.tsx`'s `/scenes`/`/content`/etc.) — no second placeholder
 * component invented for this round.
 */
import { useTranslation } from 'react-i18next'
import ComingSoon from '../../pages/ComingSoon'

export function AccountProfileComingSoon() {
  const { t } = useTranslation('accountEntry')
  return <ComingSoon title={t('comingSoon.profileTitle')} description={t('comingSoon.profileDescription')} />
}

export function PlanUsageComingSoon() {
  const { t } = useTranslation('accountEntry')
  return <ComingSoon title={t('comingSoon.planUsageTitle')} description={t('comingSoon.planUsageDescription')} />
}

export function AccountSettingsComingSoon() {
  const { t } = useTranslation('accountEntry')
  return <ComingSoon title={t('comingSoon.settingsTitle')} description={t('comingSoon.settingsDescription')} />
}

export function HelpComingSoon() {
  const { t } = useTranslation('accountEntry')
  return <ComingSoon title={t('comingSoon.helpTitle')} description={t('comingSoon.helpDescription')} />
}
